import { createFileRoute } from "@tanstack/react-router";
import AntiFrauda from "@/pages/incredere/AntiFrauda";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/incredere/anti-frauda/")({
  head: () => routeHead("/incredere/anti-frauda/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AntiFrauda />
  );
}
